export default {"src":"/_next/static/media/share.a0df7481.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};